import * as entity from 'entities';
import {
    generateUrl,
    prepare
} from "@network/axios";

const DbTableHelpers = {
    /**
     * Performs a request to the dbtable backend and returns the results
     *
     * @param post      // dbtable script to target (e.g. "submittedlist")
     * @param onSuccess // Callback to run on success
     * @param onError   // Callback to run on error
     * @param onFinally // Callback to run after the request completes (successful or otherwise)
     */
    fetch: async ({
                      onSuccess = (response) => {
                      },
                      onError = (response) => {
                      },
                      onFinally = () => {
                      },
                      ...rest
                  }) => {
        let res;

        await DbTableHelpers.fetchAsync(rest).then(async (response) => {
            res = await response.json();

            if(res.error) {
                onError(res);
                return;
            }

            onSuccess(res);
        }).catch(e => {
            onError(e);
        }).finally(() => {
            onFinally();
        });

        return res;
    },

    fetchAsync: ({
                     url = null,
                     post,
                     type = "dbtable",
                     start = 0,
                     length = 50,
                     global = true,
                     data = {},
                 }) => {
        const requestUrl = generateUrl(url);

        const requestObject = {
            post,
            type,
            _ajax: "true",
            'data[start]': start,
            'data[length]': length,
            ...prepare(data)
        }

        if (global) {
            requestObject.global = global;
        }

        return fetch(requestUrl, {
            method: "POST",
            // mode: "no-cors", // no-cors, *cors, same-origin
            headers: {
                'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
            },
            body: new URLSearchParams(requestObject).toString()
        });
    },

    fetchJson: ({
                    url = null,
                    post,
                    type = "dbtable",
                    start = 0,
                    length = 50,
                    global = true,
                    data = {},
                }) => {
        const requestUrl = generateUrl(url);

        const requestObject = {
            post,
            type,
            _ajax: "true",
            'data[start]': start,
            'data[length]': length,
            ...prepare(data)
        }

        if (global) {
            requestObject.global = global;
        }

        return fetch(requestUrl, {
            method: "POST",
            headers: {
                'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
            },
            body: new URLSearchParams(requestObject).toString()
        }).then( async (response) => {
            const parsed = await response.json();

            if (parsed.error) {
                throw Error(parsed.error);
            }

            return parsed;
        })
    },

    replaceHtmlEntities: (str) => {
        return entity.decodeHTML(str);
    },

    action: (options = {
        onBefore: () => {
        },
        onSuccess: () => {
        },
        onError: () => {
        },
        onFinally: () => {
        },
    }) => {
        (async () => {
            await DbTableHelpers.actionAsync(options);
        })();
    },

    actionAsync: (options = {
        post: undefined,
        action: undefined,
        ids: [],
        extraPayloadData: {},
        successMessage: "Successfully performed action",
        errorMessage: "Failed to perform action",
        onBefore: () => {
        },
        onSuccess: () => {
        },
        onError: () => {
        },
        onFinally: () => {
        },
    }) => {
        if (options.onBefore) {
            options.onBefore();
        }

        const idPayload = {};

        if (options.ids && options.ids.length > 0) {
            for (const id of options.ids) {
                idPayload[`ids[${id}]`] = id;
            }
        }

        return DbTableHelpers.fetch({
            post: options.post,
            data: {
                action: options.action,
                ...idPayload,
                ...options.extraPayloadData
            },
            onSuccess: options.onSuccess ? options.onSuccess.bind(options) : options.onSuccess,
            onError: options.onError ? options.onError.bind(options) : options.onError,
            onFinally: options.onFinally ? options.onFinally.bind(options) : options.onFinally,
            ...options.rest
        });
    },
    commaSeparatedValueToArray: commaSeparated => commaSeparated.split(','),
    stringArrayToArray: stringArray => stringArray.replace('[', '').replace(']','').split(','),
    convertJSON: (input) => {
        const output = {};

        function traverse(obj, prefix = [])
        {
            for(const key in obj) {
                if( typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
                    traverse(obj[key], [...prefix, key]);
                } else if (Array.isArray(obj[key])) {
                    if(prefix.length === 0) {
                        output[key] = obj[key];
                    } else {
                        output[`${prefix.map((v, o) => o == 0 ? v : `[${v}]`).join('')}[${key}]`] = JSON.stringify(obj[key]);
                    }
                } else {
                    const newKey = prefix.length === 0 ? key :  `${prefix.map((v, o) => o == 0 ? v : `[${v}]`).join('')}[${key}]`;
                    output[newKey] = obj[key];
                }
            }
        }

        traverse(input);
        return output;
    }
}

export default DbTableHelpers;